export enum DealerModuleApiSuffixModels {
  MARKETING_TYPE = 'maketing-types',
  DEALER_TYPE = 'dealer-type-config',
  DEALER_TYPE_DELETE = 'dealer-type-config/delete',
  MARKETING_BANNERS = 'maketing-banners',
  MARKETING_BANNERS_CITIES = 'ux/cities/maketing-banners',
  MARKETING_BANNERS_PROVINCES = 'ux/provinces/maketing-banners',
  MARKETING_BANNERS_SUBURBS = 'ux/suburbs/maketing-banners',
  DEALER_COMMISSION_TYPE = 'commision-config',
  DEALER_TYPE_DROPDOWN = 'ux/dealer-type',
  COMMISSION_CONFIG_DELETE = 'commision-config/delete',
  DEALET_CATEGORY_DROPDOWN = 'ux/dealer-category-type',
  DEALET_MONTH_DROPDOWN = 'ux/monthvalues',
  DEALER_BONUS_MULTIPLE = 'ux/bonusmultiple',
  DEALER_TYPE_LIST = 'dealer-type',
  DEALER_CATEGORY = 'dealer-category-type',
  DEALER = 'dealer',
  DEALER_PRINCIPLE = 'dealer-principle',
  DEALER_BRANCH = 'dealer-branch',
  DEALER_BRANCH_CATEGORY = 'dealer-branch/category',
  DEALER_BRANCH_DELETE = 'dealer-branch/delete',
  DEALER_DOCUMENT = 'dealer-document',
  DEALER_DOCUMENT_DELETE = 'dealer-document/delete',
  DEALER_DOCUMENT_TYPE = 'dealer-document-type',
  DEALER_DOC_CONFIG = 'dealer-doc-config',
  DFS_CONFIG = 'dsf-config',
  DFS_CONFIG_DELETE = 'dsf-config/delete',
  DEALER_DOCUMENT_DROPDOWN = 'ux/dealer-document',
  DEALER_TECH_AREA_DETAILS = 'dealer-tech-area-details',
  UX_DSF_CONFIG = 'dsf-config',
  UX_DEALER_EMPLOYEE_ROLES = 'ux/dealers-employee/roles',
  UX_DEALER_EMPLOYEE_BRANCH = 'ux/dealers-employee/branch',
  DEALER_SUSPENSION = 'dealer-suspension',
  DEALER_SUSPENSION_REASONS = 'ux/dealer-suspension-reasons',
  DEALER_SUSPENSION_DETAILS = 'dealer-suspension-details',
  DEALER_REINSTATE = 'dealer-reinstate',
  DEALER_TERMINATION_REASONS = 'ux/dealer-termination-reasons',
  DEALER_TERMINATION = 'dealer-termination',
  DEALER_TERMINATION_DETAILS = 'dealer-termination-details',
  DEALER_CUSTOMER = 'dealer-customer',
  DEALER_CUSTOMER_SEARCH = 'dealer-customer-search',
  DEALER_CUSTOMER_CODE = 'ux/dealer-customer-dealer',
  DEALER_CUSTOMER_BRANCH = 'ux/dealer-customer-dealer-branches',
  UX_DEALER_CUSTOMER_STATUS = 'ux/dealer-customer-status',
  UX_STATIC = 'ux/static',
  DEALER_CUSTOMER_DETAILS = 'dealer-customer-details',
  DEALER_CUSTOMER_DOCUMENT = 'dealer-customer-document',
  DEALER_CUSTOMER_EXISTING_DETAILS = 'dealer-customer-existing-details',
  DEALER_CUSTOMER_HEADER_DETAILS = 'dealer-customer-header-details',
  CREDIT_VETTING = 'credit-vetting',
  CREDIT_VETTING_AVS_CHECK = 'credit-vetting-avscheck',
  DEALER_SERVICES = 'dealer-services',
  DEALER_PARTITIONS_GENERATE = 'dealer-partitions/generate',
  DEALER_SERVICE_DETAILS = 'dealer-services-details',
  DEALER_PARTITIONS = 'dealer-partitions',
  DEALER_STOCK_SELLING_PRICE = 'Dealerstock/selling-price',
  DEALER_STOCK_SELLING_PRICE_JOB = 'Dealer-stock/selling-price-job',
  DEALER_STOCK_SCHEDULE_SELLING_PRICE = 'Dealer-stock/schedule-selling-price',
  DEALER_STOCK_SELLING_PRICE_JOB_DETAILS_LIST = 'Dealer-stock/selling-price-job/details/list',
  DEALER_STOCK_SELLING_PRICE_DETAILS = 'Dealerstock/selling-price-details',
  DEALER_STOCK_SELLING_PRICE_HISTORY = 'Dealerstock/selling-price-history',
  DEALER_PARTITIONS_SEARCH = 'dealer-partitions-search',
  DEALER_SUMMARY_DETAILS = 'dealer-services-summary-details',
  DEALER_SUMMARY_TAB_DETAILS = 'dealer-services-agreement-tab-details',
  DEALER_BRANCH_CATEGORY_LIST = 'dealer-branch-category-List',
  DEALER_BRANCH_CATEGORY_API = 'dealer-branch-category',
  DEALER_BRANCH_CATEGORY_DETAILS = 'dealer-branch-category-Details',
  UX_DEALER_BRANCH_CATEGORY_COMMISSION_TYPE = 'ux/dealer-branch-category-commission-type',
  DEALER_STOCK_ORDER = 'dealer-stock-order',
  DEALER_STOCK_ORDER_CANCELLATION = "DealerStockOrderCancellation",
  UX_DEALER = 'ux/dealer',
  ORDER_DEALER_TYPES = 'ux/DealerStockOrders',
  UX_DEALER_STOCK_ORDER_CANCELLATION = 'ux/DealerStockOrderCancellation',
  UX_DEALER_BRANCH = 'ux/dealer-branch',
  ACCESS_TO_PREMISES = 'dealers/access-premises',
  DEALER_AVERAGE_CONTRACT = 'average-contract-config',
  DEALER_AVERAGE_CONTRACT_DETAIL = 'average-contract-config-detail',
  DEALERS_EMPLOYEE = 'dealers-employee',
  CELL_PANIC = 'cell-panic',
  DOMESTIC_WORKERS = 'dealer/domestic-workers',
  GET_DOMESTIC_WORKERS = 'dealer/domestic-workers/domestic/details',
  KEYHOLDER_POST = 'dealer/key-holders',
  KEYHOLDER_GET = 'dealer/key-holders/details',
  OPEN_CLOSE_MONITORING = 'open-close-monitoring',
  SITE_HAZARD = 'dealer-site-hazards',
  SITE_HAZARD_SERVICES = 'dealer-site-hazards/services',
  FIND_U_USERS = 'dealers/findu-users',
  CUSTOMER_IDENTIFICATION = 'customer-identification',
  CUSTOMER_IDENTIFICATION_AGREEMENT_TAB_POST = 'agreement-tabs/customer-identification',
  PASSWORD_SPECIAL_INSTRUCTIONS = 'special-instructions',
  DEALER_CONTRACTS = 'dealer-contracts',
  DEALER_TASK_LIST = 'dealer-task-list',
  DEALER_APPROVAL = 'dealer-approval',
  DEALER_APPROVAL_REQUEST = 'dealer-approval-request',
  DEALER_DOCUMENT_COMMENT_HISTORY = 'dealer-document-comment-history',
  DEALER_CUSTOMER_APPROVAL = 'dealer-customer-approval',
  DEALER_CUSTOMER_APPROVAL_DETAILS = 'dealer-customer-approval-details',
  DEALER_CUSTOMER_VERIFICATION_DETAILS = 'dealer-customer-verification-details',
  DEALER_CUSTOMER_VERIFICATION = 'dealer-customer-verification',
  DEALER_EMPLOYEE_SUSPENSION = 'dealers-employee/suspend',
  DEALER_EMPLOYE_REINSTATE = 'dealers-employee/reinstate',
  DEALER_EMPLOYEE_TERMINATION = 'dealers-employee/termination',
  DEALER_BILLING_CONFIG_WEEKLY = 'dealer-billing-config-weekly/list',
  DEALER_BILLING_CONFIG_WEEKLY_CREATE = '/dealer-billing-config-weekly/create',
  DEALER_BILLING_CONFIG_WEEKLY_UPDATE = 'dealer-billing-config-weekly/update',
  DEALER_BILLING_CONFIG_WEEKLY_DETAIL = 'dealer-billing-config-/weekly/detail',
  DEALER_BILLING_CONFIG_MONTHLY = 'dealer-billing-config-monthly/list',
  DEALER_BILLING_CONFIG_MONTHLY_CREATE = 'dealer-billing-config-monthly/create',
  DEALER_BILLING_CONFIG_MONTHLY_UPDATE = 'dealer-billing-config-monthly/update',
  DEALER_BILLING_CONFIG_MONTHLY_DETAIL = 'dealer-billing-config-monthly/detail',
  DEALER_BILLING_CONFIG_QUATERLY = 'dealer-billing-config-quaterly/list',
  DEALER_BILLING_CONFIG_QUATERLY_CREATE = 'dealer-billing-config-quaterly/create',
  DEALER_BILLING_CONFIG_QUATERLY_UPDATE = 'dealer-billing-config-quaterly/update',
  DEALER_BILLING_CONFIG_QUATERLY_DETAIL = 'dealer-billing-config-quaterly/detail',
  DEALER_BILLING_CONFIG_YEARLY = 'dealer-billing-config-yearly/list',
  DEALER_BILLING_CONFIG_YEARLY_CREATE = '/dealer-billing-config-yearly/create',
  DEALER_BILLING_CONFIG_YEARLY_UPDATE = '/dealer-billing-config-yearly/update',
  DEALER_BILLING_CONFIG_YEARLY_DETAIL = 'dealer-billing-config-yearly/detail',
  DEALER_BILLING_CONFIG_DAYS = 'ux/dealer-billing-config/days',
  DEALER_BILLING_CONFIG_MONTHS = 'ux/dealer-billing-config/months',
  DEALER_EMPLOYE_USER_DETAILS = 'dealers-employee/user-details',
  DEALER_STORAGE_LOCATION = 'dealer-storage-location',
  DEALER_BILLING_CLAWBACK = "dealer-billing-clawbacks",
  DEALER_BILLING_CLAWBACK_REASONS = "ux/clawback-reasons",
  DEALER_BILLING_CLAWBACK_COMMISSIONS_CUSTOMER = "ux/dealer-billing-commissions-customers",
  DEALER_BILLING_CLAWBACK_COMMISSIONS_CUSTOMER_DETAIL = "dealer-billing-commissions-customer",
  DEALER_BILLING_CLAWBACK_REVERSALS = "dealer-billing-clawback-reversals",
  UX_DEALER_BILLING_CLAWBACK_REVERSALS_CUSTOMERS = "ux/dealer-billing-clawback-reversals-customers",
  DEALER_STOCK_ORDER_COLLECTION = 'Dealer-Stock-Order-Collections',
  DEALER_STOCK_ORDER_COLLECTION_STOCK_DETAILS = 'Dealer-Stock-Order-Collections-StockDetails',
  DEALER_STOCK_ORDER_COLLECTION_EXPORT = 'Dealer-Stock-Order-Collections-export',

  SERIAL_NUMBER_COLLECTION_LIST = 'Dealer-Stock-Order-Collections-StockDetails',
  DEALER_RECURRING_REVENUE = 'dealer-recurring-revenue',
  UX_SERVICE_PARTITIONS = 'ux/dealer-partition',
  RESEND_VERIFICATION_LINK = 'dealers-employee/resend-verification-link',
  DEALER_MANDATORY_FIELDS = 'dealer-mandatory-fields-config/list',
  DEALER_MANDATORY_FIELDS_CONFIG = 'dealer-mandatory-fields-config',
  DEALER_BRANCH_TECHAREA_VALIDATION = 'dealer-branch-techarea-validation',
  DEALER_DOCUMENT_VALIDATION = 'dealer-document-validate',

}
export enum FEATURE_BILLING_NAME {
  WEEKLY = 'weekly',
  MONTHLY = 'monthly',
  QUATERLY = 'quaterly',
  YEARLY = 'yearly'
}

export enum DEALER_COMPONENT {
  DEALER_MAINTENANCE = "Dealer Maintenance",
  DEALER_TYPE = "Dealer Type",
  DEALER_CATEGORY = "Dealer Category",
  DEALER_COMMISSION_CONFIGURATION = "Dealer Commission Configuration",
  DEALER_TYPE_CONFIGURATION = "Dealer Type Configuration",
  DEALER_DOCUMENT_TYPE = "Dealer Document Type",
  DEALER_REQUIRED_DOCUMENT = "Dealer Required Document",
  AVERAE_CONTRACT_PRICE = "Average Contract Price",
  DSF_CONFIG = "DSF Config",
  CUSTOMER_CONTRACT = "Customer Contract",
  DEALER_STOCK_ORDER = "Dealer Stock Order",
  DEALER_STAFF_REGISTRATION = "Dealer Staff Registration",
  DEALER_BILLING_MANAGEMENT = "Dealer Billing Management",
  DEALER_BILLING = "Dealer Billing",
  CANCEL_STOCK_ORDER = "Cancel Stock Order",
  CLAWBACK = "Clawback",
  CLAWBACK_REVERSAL = "Clawback Reversal",
  MARKETING_TYPE_CONFIG = 'Marketing Type Config',
  MARKETING_BANNER = 'Marketing Banner',
}
